import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { ColorPaletteGroupContext, } from './ColorPaletteGroup.context';
export const ColorPaletteGroupProvider = (props) => {
    const { children, customColors } = props;
    const [quantizedPalette, setQuantizedPalette] = useState();
    const contextValue = {
        customColors,
        quantizedPalette,
        setQuantizedPalette,
    };
    return (_jsx(ColorPaletteGroupContext.Provider, { value: contextValue, children: children }));
};
